import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";





'use strict';




const helpers = {
  datepicker(data) {
    const requiredAttrs = ['id'];
    const reservedAttrs = ['type', 'data-mask', 'data-gis-mask'];
    const inline = !!data.datepicker.inline;
    const calendarSkin = data.datepicker.skin || 'default-design';

    const combinableAttrs = {
      class: `datepicker${inline ? '' : ' spa-input-text'}`,
      value: '',
    };
    const applyGISMask = data.datepicker['gis-mask'];
    const validationRules = data.validationRules;
    let attrsStr = '';
    let output = '';

    if (typeof applyGISMask !== 'undefined') {
      combinableAttrs.class += ' gis-mask';
      data.input.attrs['data-field-type'] = applyGISMask;
    }

    if (!Handlebars.helpers.requiredAttrsCheck(data.datepicker.attrs, requiredAttrs).pass) {

      global.nodeModules.grunt.fail.fatal(`You are missing the required attribute ${
        Handlebars.helpers.requiredAttrsCheck(data.datepicker.attrs, requiredAttrs).missingField
      }`);
    }

    Handlebars.helpers.removeReservedAttrs(data.datepicker.attrs, reservedAttrs);
    Handlebars.helpers.combineAttrs(data.datepicker.attrs, combinableAttrs);
    attrsStr = Handlebars.helpers.buildAttrsString(data.datepicker.attrs);

    const containerClasses = `spa-input spa-input--sparta2 spa-input-box spa-date-input spa-date-input--${
      calendarSkin
    } spa-input--${
      data.skin ? data.skin : 'material-design'
    } ${
      data.containerClasses ? data.containerClasses.join(' ') : ''
    }`;

    const inputLabelRequiredSpan = (required, asterisk) => {
      if (required && asterisk === false) {
        return "<span class='spa-input-label--required'></span>";
      } else if (required) {
        return "<span class='spa-input-label--required'> *</span>";
      }
      return "";
    };

    output = inline
      ? `
        <div class="${containerClasses}" ${data.required ? 'required aria-required="true"' : ''}>
          <div ${attrsStr}></div>
        </div>
      `
      : `
        <div class="${containerClasses} ${
          data.datepicker.attrs.value ? '' : 'spa-input--empty'
        }" data-calendar-skin="${calendarSkin}">
          <label class="spa-input-label" for="${data.datepicker.attrs.id}" data-font="cnx-medium">
            ${data.label.text}${
              inputLabelRequiredSpan(data.required, data.asterisk)
            }
            <span class="ada-hidden">${data.label.adaText || ''}</span>
          </label>
          <input type="text" ${attrsStr} ${
            validationRules
            ? `data-validation-rules='${JSON.stringify(validationRules).replace(/'/g, '&#39;')}'`
            : ''
          } ${data.required ? 'required aria-required="true"' : ''}>
          <p class="spa-input-hint">${data.hintText ? data.hintText : ''